import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

const Shortcode = ({ shortcode }) => {
  const [content, setContent] = useState("");

  useEffect(() => {
    if (!shortcode) {
      return;
    }

    const fetchShortcodeContent = async () => {
      try {
        const response = await fetch(
          `/wp-json/wp/v2/shortcode-renderer?shortcode=${encodeURIComponent(shortcode)}`
        );
        const data = await response.json();

        if (data.output) {
          setContent(data.output);
        }
      } catch (error) {
        console.error("Error fetching shortcode content:", error);
      }
    };

    fetchShortcodeContent();
  }, [shortcode]);

  return <div dangerouslySetInnerHTML={{ __html: content }} />;
};

Shortcode.propTypes = {
  shortcode: PropTypes.string.isRequired,
};

export default Shortcode;
